<template>
    <div class="mobile_body">
        <div style="overflow: hidden;margin-bottom: 10px;">
            <div style="float: left;width:40%;">
                <el-input placeholder="政策名称" v-model="name" style="width:90%;" clearable></el-input>
            </div>
            <div style="float: left;width:40%;">
                <el-select v-model="type" placeholder="扶持类型" clearable  style="width:90%;">
                    <el-option
                        v-for="item in typeList"
                        :key="item.key"
                        :label="item.label"
                        :value="item.key">
                    </el-option>
                </el-select>
            </div>
            <div style="float: left;width:20%;">
                <el-button type="success" style="width:100%;" @click="getList">查询</el-button>
            </div>
        </div>
        <div>
            <el-tabs v-model="activeName">
                <el-tab-pane label="全部" name="">
                    <div class="tab_content">
                        <div class="tab_content_item" v-for="(item,i) in dataList" :key="i" @click="detail(item.policyId)">
                            <div class="text1">{{ item.policyName }}</div>
                            <div class="text2">有效时间：{{ item.startTime }} 至 长期有效</div>
                            <div class="text2">发布时间：{{ item.publictime }}</div>
                            <div class="text4">
                                <div>{{ item.deptName }}</div>
                            </div>
                        </div>
                        <el-empty v-if="dataList.length === 0" description="暂无数据"></el-empty>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="省级" name="1">
                    <div class="tab_content">
                        <div class="tab_content_item" v-for="(item,i) in dataList2" :key="i" @click="detail(item.policyId)">
                            <div class="text1">{{ item.policyName }}</div>
                            <div class="text2">有效时间：{{ item.startTime }} 至 长期有效</div>
                            <div class="text2">发布时间：{{ item.publictime }}</div>
                            <div class="text4">
                                <div>{{ item.deptName }}</div>
                            </div>
                        </div>
                        <el-empty v-if="dataList2.length === 0" description="暂无数据"></el-empty>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="市级" name="2">
                    <div class="tab_content">
                        <div class="tab_content_item" v-for="(item,i) in dataList3" :key="i" @click="detail(item.policyId)">
                            <div class="text1">{{ item.policyName }}</div>
                            <div class="text2">有效时间：{{ item.startTime }} 至 长期有效</div>
                            <div class="text2">发布时间：{{ item.publictime }}</div>
                            <div class="text4">
                                <div>{{ item.deptName }}</div>
                            </div>
                        </div>
                        <el-empty v-if="dataList3.length === 0" description="暂无数据"></el-empty>
                    </div>
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            activeName: '',
            name:'',
            type:'',
            dataList:[],
            dataList2:[],
            dataList3:[],
            typeList:[],
        }
    },
    created(){
        this.getList();
        this.getType();
    },
    methods: {
        getList() {
            let param = {
                "keyWord": this.name,
                "zcfs": this.type,
                "policyLevel": '',
                "pageSize": 50,
                "pageNum": 1
            }
            let param2 = {
                "keyWord": this.name,
                "zcfs": this.type,
                "policyLevel": '1',
                "pageSize": 50,
                "pageNum": 1
            }
            let param3 = {
                "keyWord": this.name,
                "zcfs": this.type,
                "policyLevel": '2',
                "pageSize": 50,
                "pageNum": 1
            }
            const url = '/dev-api/avoid/apply/selectAvoidApplyList';
            this.$httpApi.post(url, param).then((r) => {
                this.dataList = r.data.list;
            })
            this.$httpApi.post(url, param2).then((r) => {
                this.dataList2 = r.data.list;
            })
            this.$httpApi.post(url, param3).then((r) => {
                this.dataList3 = r.data.list;
            })
            .catch((e) => { });
        },
        getType() {
            const url = '/dev-api/system/dict/getDictListByType?dictType=sq_policy_zjlx'
            this.$httpApi.get(url, {}).then((r) => {

                this.typeList = r.data;
                console.log('this.typeList::',this.typeList);
            })
            .catch((e) => { });

        },
        detail(policyId){
            this.$router.push({
                path:`/msjxMobile/detail?policyId=${policyId}`,
            })
        }
    },
}
</script>
<style lang="scss" scoped>
.mobile_body {
    padding: 10px 20px;
    max-width: 450px;
    font-size: 16px;
    margin: 0 auto;

    .tab_content {
        height: calc(100vh - 130px);
        overflow-y: auto;
        .tab_content_item{
            padding: 10px 0;
            border-bottom: 1px solid #ccc;

            .text1 {
                font-weight: 600;
            }

            .text2 {
                color: #949393;
                margin-top: 10px;
                font-size: 14px;
            }

            .text4 {
                margin-top: 10px;

                >div {
                    position: relative;
                    float: right;
                    border: 1px solid #5AC725;
                    margin-top: -32px;
                    padding: 2px 6px;
                    color: #36AB60;
                    font-size:12px;
                }
            }
        }

    }
}
::v-deep{
    .el-tabs__item {
        font-size: 20px;
        font-weight: 600;
    }
}
*::-webkit-scrollbar {
    width: 0px;
    height: 1vh;
}
</style>
